import Administration from './Administration/Administration';
import Statistics from './Statistics/Statistics';
import Forecast from './Forecast';
import Students from './Students';
import General from './General';
import User from './User';

export default class DataAccess {
    static Administration = Administration;
    static Statistics = Statistics;
    static Students = Students;
    static General = General;
    static Forecast = Forecast;
    static User = User;
}

export {
    Administration,
    Statistics,
    Forecast,
    Students,
    General,
    User
}